import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiExternalLink } from "react-icons/fi";
import { GoPrimitiveDot } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { CancelTrainingRequest } from "../../../../../utils/redux/HR/HRSlice";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import PageLayout from "../../../Components/Layout/PageLayout";
import { PageActions } from "../../../Components/Misc/Actions";
import { GetRecommendations } from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import {
  FormatStatus,
  getColorByStatus,
} from "../../../../../utils/functions/FormatStatus";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";

function ViewRecommendations() {
  const navigate = useNavigate();

  const formMethods = useForm({
    mode: "all",
  });
  const { handleSubmit } = formMethods;

  const submit = (e) => {
    alert("clicked");
  };

  const dispatch = useDispatch();

  // const emp_req = useSelector((state) => state?.hr);
  // const requisition = emp_req?.emp_req;

  const { id } = useParams();

  let requisition = useSelector((state) =>
    state?.companyFund?.Recommendations?.result?.length
      ? state.companyFund.Recommendations.result[0]
      : {}
  );

  useEffect(() => {
    dispatch(
      GetRecommendations({
        pageSize: 10,
        pageNumber: 1,
        ID: id,
      })
    );
  }, [dispatch]);

  return (
    <PageLayout title={"Recommended Investment Details"} hasBack={true}>
      {/* <div className={DashboardStyle.app_view_controls}>
        <PageActions>
          {[
            {
              name: "Cancel Requisition",
              action: () => {
                openModal({
                  type: "suspend",
                  details: {
                    button: {
                      name: "Delete",
                      color: "red",
                    },
                    isDelete: true,
                    isDeleteHero: "",
                    isDeleteSupport:
                      "Are you sure you want to delete this requisition? This action cannot be undone.",
                    title: "Delete Asset Requisition",
                    submitData: (data) => {
                      dispatch(
                        CancelTrainingRequest({
                          comment: data?.comments,
                          id: +id,
                          emailTrigger: data?.send,
                        })
                      )?.then((res) => {
                        if (res?.payload?.successful === true) {
                          closeModal();
                          // dispatch(GetSingleProcRequisitions(id));
                          navigate("../");
                        }
                      });
                    },
                  },
                });
              },
              //   permissions: !DEFINED_PERMISSIONS.ProcurementRequisitionApproval
            },

            {
              name: "Update Requisition",
              action: () => {
                navigate(`../${id}/edit`, { state: requisition });
              },
              //   permissions: !DEFINED_PERMISSIONS.ProcurementRequisitionAdd
            },
          ]}
        </PageActions>
      </div> */}
      <FormProvider {...formMethods}>
        <FormTemplate
          className={DashboardStyle.view_app_components}
          handleSubmit={handleSubmit(submit)}
        >
          {/* Process Information Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
            Investment
            <br />
             Details
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                {/* Initiator Information */}
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Initiated By:</p>
                    <h4>{requisition?.ftLedger?.initiatorName}</h4>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Date Created:</p>
                    <h4>
                      {FormatDateTime(requisition?.ftLedger?.dteCreated, "ll")}
                    </h4>
                  </div>
                </div>

                {/* Created By and Date */}
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Created By:</p>
                    <h4>{requisition?.ftLedger?.initiatorName}</h4>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Last Updated:</p>
                    <h4>{FormatDateTime(requisition?.updatedDate, "ll")}</h4>
                  </div>
                </div>

                {/* Last Reviewed */}
                <div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Available Balance:</p>
                    <h4>{FormatCurrency(requisition?.availableBalance)}</h4>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginBottom: "0.8rem",
                      gap: "0.6rem",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ marginBottom: "0px" }}>Investible Amount:</p>
                    <h4>{FormatCurrency(requisition?.investibleAmount)}</h4>
                  </div>
                </div>
              </div>

              {/* Approval Section */}
              <div>
                <div>
                  <p>Status:</p>
                  <h4>
                    <span
                      style={{
                        color: getColorByStatus(requisition?.approvalStatus)
                          .color,
                        backgroundColor: getColorByStatus(
                          requisition?.approvalStatus
                        ).backgroundColor,
                        padding: "4px", // Optional padding for better visual presentation
                        borderRadius: "4px", // Optional rounded corners
                      }}
                    >
                      {FormatStatus(requisition?.approvalStatus)}
                    </span>
                  </h4>
                </div>
                <div>
                  <p>Batch Id:</p>
                  <h4>{requisition?.batchId}</h4>
                </div>
              </div>
            </div>
          </section>

          {/* Requisition Information Section */}
          <section
            style={{
              borderTop: "unset",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Bank <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Account Name</p>
                  <h4>{requisition?.ftLedger?.accountName}</h4>
                </div>
                <div>
                  <p>Account Number</p>
                  <h4>{requisition?.ftLedger?.accountNumber}</h4>
                </div>
                {/* <div>
                  <p>Opening Balance</p>
                  <h4>{requisition?.ftLedger?.openingBal}</h4>
                </div>
                <div>
                  <p>Closing Balance</p>
                  <h4>{requisition?.ftLedger?.closingBal}</h4>
                </div> */}
              </div>

              {/* <div>
                <div>
                  <p>Cost</p>
                  <h4>{requisition?.ftLedger?.cost}</h4>
                </div>
                <div>
                  <p>Description</p>
                  <h4>{requisition?.ftLedger?.description || "N/A"}</h4>
                </div>
                <div>
                  <p>Authorized Status</p>
                  <h4>
                    {requisition?.ftLedger?.authorizedStatus === 1
                      ? "Authorized"
                      : "Unauthorized"}
                  </h4>
                </div>
              </div> */}
            </div>
          </section>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default ViewRecommendations;
